import { ReactNode, MouseEvent } from "react";
import {
  Avatar,
  Card,
  CardContent,
  Stack,
  SxProps,
  Theme,
  Typography,
} from "@mui/material";

export const OverviewCard = ({
  sx,
  value,
  title,
  icon,
  backgroundIcon,
  onClick,
}: {
  sx: SxProps<Theme>;
  value?: number | string;
  title: string;
  icon?: ReactNode;
  backgroundIcon?: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}) => {
  return (
    <Card sx={sx} onClick={onClick}>
      <CardContent sx={{ minHeight: "100px" }}>
        <Stack
          alignItems="flex-start"
          direction="row"
          justifyContent="space-between"
        >
          <Stack spacing={1}>
            <Typography
              color="text.secondary"
              variant="h5"
              sx={{
                textTransform: "uppercase",
                fontWeight: "bold",
                marginTop: "32px !important",
              }}
            >
              {title}
            </Typography>
          </Stack>
          <Avatar
            sx={{
              backgroundColor: backgroundIcon ?? "error.main",
              height: 84,
              width: 84,
            }}
          >
            {icon || <Typography variant="h4">{value}</Typography>}
          </Avatar>
        </Stack>
      </CardContent>
    </Card>
  );
};
